import store from "../../redux/store";

function GetHasRedigera(avdid) {
  var state = store.getState();
  if (!state || !state.user.user || !state.user.user.id) return false;
  const avd = state.user.user.avdelnings.find((obj) => {
    return obj.id === avdid;
  });
  if (!avd) return false;
  return avd.hasRedigera;
}

store.subscribe(GetHasRedigera);

export default GetHasRedigera;
